const REF_KEY = "yrd_ref";

/** Capture ?ref= param from URL and persist in localStorage */
export const captureReferral = (): void => {
  const params = new URLSearchParams(window.location.search);
  const ref = params.get("ref");
  if (ref) {
    localStorage.setItem(REF_KEY, ref.trim().toLowerCase());
  }
};

/** Get the stored referral source, if any */
export const getReferral = (): string | null => {
  return localStorage.getItem(REF_KEY);
};
